// extracted by mini-css-extract-plugin
module.exports = {"certification":"Certification_certification__BHn79","certTitle":"Certification_certTitle__3ydlC"};